"use client";

import { useState } from "react";
import { AnimatePresence, motion } from "motion/react";
import { useTranslations } from "next-intl";

export function Faq() {
  const t = useTranslations("home.faq");
  const items = t.raw("items") as { q: string; a: string }[];
  const [open, setOpen] = useState(-1);

  return (
    <section className="mx-auto mt-[108px] max-w-[820px] px-7">
      <div className="text-center">
        <h2 className="mt-3 text-balance font-display text-[38px] font-extrabold leading-[1.07] tracking-tighter max-[560px]:text-[30px]">
          {t("title")}
        </h2>
      </div>

      <div className="mt-8 flex flex-col gap-3">
        {items.map((f, i) => {
          const isOpen = open === i;
          return (
            <div
              key={i}
              className="overflow-hidden rounded-card border border-[rgba(40,20,8,.08)] bg-white"
            >
              <button
                onClick={() => setOpen(isOpen ? -1 : i)}
                aria-expanded={isOpen}
                className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-[18px] text-left transition hover:bg-[#FBF6F0]"
              >
                <span className="font-display text-[16.5px] font-bold text-espresso">
                  {f.q}
                </span>
                <span className="flex h-7 w-7 flex-none items-center justify-center rounded-full bg-cream-panel text-lg font-bold text-terracotta">
                  {isOpen ? "–" : "+"}
                </span>
              </button>
              <AnimatePresence initial={false}>
                {isOpen && (
                  <motion.div
                    initial={{ height: 0, opacity: 0 }}
                    animate={{ height: "auto", opacity: 1 }}
                    exit={{ height: 0, opacity: 0 }}
                    transition={{ duration: 0.3, ease: "easeInOut" }}
                    className="overflow-hidden"
                  >
                    <p className="px-5 pb-5 text-[14.5px] leading-[1.6] text-ink-soft">
                      {f.a}
                    </p>
                  </motion.div>
                )}
              </AnimatePresence>
            </div>
          );
        })}
      </div>
    </section>
  );
}
